import { Content } from './styled';
export function TemplateDrawerContent(props) {
    const { children } = props;
    return <Content>{children}</Content>;
}
